import { render, staticRenderFns } from "./BookYearSelect.vue?vue&type=template&id=54cbd2ab"
import script from "./BookYearSelect.vue?vue&type=script&lang=ts"
export * from "./BookYearSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54cbd2ab')) {
      api.createRecord('54cbd2ab', component.options)
    } else {
      api.reload('54cbd2ab', component.options)
    }
    module.hot.accept("./BookYearSelect.vue?vue&type=template&id=54cbd2ab", function () {
      api.rerender('54cbd2ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookyear/BookYearSelect.vue"
export default component.exports